import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { translate } from 'react-i18next';
import {gtmSend, esCape} from '../../../helpers';
import history from '../../../other/history';
import {questionReply, showLoginModal} from '../../../actions/index';
import Loader from '../../../components/Common/Loader';
// import style from './style.css';
import ReplyInputComponent from '../../../components/Elems/ReplyInput';
import ReplyGenericInputModal from '../../../components/Common/CardComponents/ReplyGenericInputModal';

class ReplyInputContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {isModalOpen: false, content:"", modalImagePreviews: [], modalImages: [],isValidData: false, showUploadInput: true};
    }

    componentDidMount() {
        if(history.location.state && 'shouldOpenReplyDialog' in history.location.state){            
            if(history.location.state.shouldOpenReplyDialog) {
                this.openReplyModal();
            }
        }
    }

    goToSingleView = () => {
        window.location.href = `/q/${this.props.slug}/${this.props.id}`
    }

    onInputClickHandler = (e) => {
        if(!this.props.userReducer.id) {
            gtmSend('dynamic', 'Login Popup', 'open-trigged', `Write reply | ${this.props.match.path}`);
            gtmSend('login_popup_open', 'Login Popup', 'Open', `Write reply | ${this.props.match.path}`, 0, {action: 'Open'});
            this.props.showLoginModal();
        } else {
            this.props.inFeed ? this.replyClickFakeHandler(e) : this.replyClickHandler(e);
        }        
    }

    replyClickHandler = () => {
        this.openReplyModal();
    }

    replyClickFakeHandler = () => {
        this.goToSingleView({shouldOpenReplyDialog: true});
    }

    openReplyModal = () => {
        this.setState({isModalOpen: true});
    }

    closeReplyModal = () => {
        this.setState({isModalOpen: false});
    }

    onReplyModalOpen = () => {
        //dialog fix
        const state = {};
        history.replace({...history.location, state});
    }

    onReplyModalClose = () => {
        this.setState({isModalOpen: false, content:"", modalImagePreviews: [], modalImages: [], showUploadInput: true, isValidData: false});
    }

    onReplyModalContentChange = (content) => {
        this.setState({content});
    }

    onReplyModalImageUpload = (e) => {        
        if(e.target.files.length) {
            gtmSend('dynamic', 'Reply Input', 'click-image-upload', '');
            for(let k = 0, l = e.target.files.length; k < l; k++) {
                const reader = new FileReader();
                reader.readAsDataURL(e.target.files[k]);
                reader.onload = (i) => {
                    const base64Result = i.target.result;
                    this.setState({
                        modalImagePreviews: [...this.state.modalImagePreviews, base64Result],
                        modalImages: [...this.state.modalImages, base64Result.split(',')[1]],
                        showUploadInput: false
                    });
                };   
            }
        }
    }

    onReplyModalSubmit = (e) => {
        e.preventDefault();
        const {postReducer} = this.props;
        const message = esCape(this.state.content);
        if(!message.length) return this._addNotificationToModal(this.props.t('you_need_to_type_something'), 'error');
        const anonymous = e.target.anonymous.value,
        isActive = 1,
        questionId = this.props.id;
        gtmSend('dynamic', 'Reply Input', 'click-submit', `submit:${questionId}`);
        gtmSend('cw_reply_submit', `${this.props.cardName}`, 'Reply Submit', `${anonymous === '1' ? 'Anonymous': 'Identified'} - ${postReducer.data.topic.group.name}`, 0, {card_id: `${postReducer.id}`, card_type: `${this.props.cardName}`, topic_name: `${postReducer.data.topic.group.name}`, topic_id: `${postReducer.data.topic.group.id}`});
        // gtmSend('submit reply', 'card-reply', 'submit:reply', questionId);
        //submit  
       
        this.setState({isValidData: true});
        if(this.state.modalImages.length) {
            this.props.questionReply(questionId, message, anonymous, isActive, this.state.modalImages[0])
            .then(()=>{                
                if(!this.props.postReducer.error)
                {
                    this.onReplyModalClose();
                }else{
                    this.setState({isValidData: false});
                    return this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
                } });
        } else {
            this.props.questionReply(questionId, message, anonymous, isActive)
            .then(()=>{
                if(!this.props.postReducer.error)
                {
                    this.onReplyModalClose();
                }else{
                    this.setState({isValidData: false});
                    return this._addNotificationMessageToModal(this.props.postReducer.error, 'error');
                }
        });
        }
    }

    onPreviewImageRemove = (index) => {
        gtmSend('dynamic', 'Reply Input', 'click-remove-image-preview', '');
        this.setState({
            modalImagePreviews: [...this.state.modalImagePreviews.slice(0, index), ...this.state.modalImagePreviews.slice(index+1)],
            modalImages: [...this.state.modalImages.slice(0, index), ...this.state.modalImages.slice(index+1)],
            showUploadInput: true
        });
    }    

    onHashClick = () => {
        gtmSend('dynamic', 'Reply Input', 'click-hash', '');
        let content = this.state.content;
        content += ' #';
        this.setState({content});
        document.getElementById("generic-input-modal-desc").focus();
    }

    render() {
        const {t, postReducer, userReducer, inFeed, cardName, match} = this.props,
        eventHandlers = {
            onModalOpen: this.onReplyModalOpen,
            onModalClose: this.onReplyModalClose,
            onSubmit: this.onReplyModalSubmit,
            onImageUpload: this.onReplyModalImageUpload,
            onContentChange: this.onReplyModalContentChange,
            onPreviewImageRemove: this.onPreviewImageRemove,
            refAddNotification: (f) => this._addNotificationToModal = f,
            refAddNotificationMessage: (f) => this._addNotificationMessageToModal = f
        };

        return (
            <React.Fragment>
                {postReducer.isLoading && <Loader />}

                <ReplyInputComponent clickHandler={this.onInputClickHandler} 
                    user={userReducer}
                    cardName= {cardName}
                    match={match} />
                { 
                    !inFeed && 
                    <ReplyGenericInputModal isModalOpen={this.state.isModalOpen}
                        eventHandlers={eventHandlers}     
                        gtmLabel={'Reply Input'}    
                        cardName= {cardName}  
                        topic={postReducer.data.topic.group}  
                        id={postReducer.id}           
                        content={this.state.content}
                        imagePreviews={this.state.modalImagePreviews}
                        user={userReducer}
                        showUploadInput={this.state.showUploadInput}
                        showNSFW={false}
                        showAnonymous={userReducer.country === 'id' ? false : true}
                        contentPlaceholder={t('add_reply_placeholder')}
                        mobileTitle={t('detail_reply_placeholder')}
                        buttonLabel={t('add_reply_post')}
                        isValidData={this.state.isValidData} /> 
                }
            </React.Fragment>
        );
    }

}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionReply,
        showLoginModal
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(translate('common', {'withRef': true})(ReplyInputContainer));
